import React, { useState } from "react";
import { Modal } from "antd";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import dayjs from "dayjs";
import { Container } from "react-bootstrap";
// import moment from "moment";
// import RangePicker from "../../../components/comment/rangepicker/rangePicker";
import TimePicker from "./timePicker";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { CalendarOutlined } from "@ant-design/icons";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";

const DateModel = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };


  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const format = "HH:mm";

  const [value, setValue] = React.useState(dayjs());

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <div className="date-section ">
      <span className="trip-calendar-icon">
        <CalendarOutlined />
      </span>

      <input
        type="text"
        className="date-input-wrap"
        placeholder={props.title}
        onClick={showModal}
      />
      {/* <Button  >
    
        <p> {props.title}</p>
      </Button> */}

      <Modal
        className="modal-address-section "
        visible={isModalVisible}
        //onOk={this.handleOk}
        onCancel={handleCancel}
        footer={null}
        title={null}
        header={null}
        centered=" true"
        // closable={null}
      >
        <Container className="p-0 mx-0 ">
          <div className="pickup-dropp-off-wrap trip-date-wrap">
            <div className="select-title-wrap">
              <div className="row">
                <div className="col-lg-12">
                  <div className="select-title">
                    <EventAvailableIcon className="select-icon" />
                    <span>Choose trip date</span>
                  </div>
                </div>
              </div>
            </div>

            <Row>
              <Col md={6} className=" mt-2">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Stack spacing={3}>
                    <MobileDatePicker
                      label="start date"
                      inputFormat="MM/DD/YYYY"
                      value={value}
                      onChange={handleChange}
                      renderInput={(params) => <TextField className="date-picker-input" {...params} />}
                    />
                  </Stack>
                </LocalizationProvider>
              </Col>
              <Col md={6} className=" mt-2">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Stack spacing={3}>
                    <MobileDatePicker
                      className="mt-4"
                      label="end date"
                      inputFormat="MM/DD/YYYY"
                      value={value}
                      onChange={handleChange}
                      renderInput={(params) => <TextField className="date-picker-input" {...params} />}
                    />
                  </Stack>
                </LocalizationProvider>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="pickup-main-wrap">
                  <label className="pickup-label"> Pickup time</label>
                  <TimePicker
                    use12Hours
                    showNow={false}
                    format={format}
                    minuteStep={15}
                    secondStep={10}
                  />
                </div>
              </Col>
              <Col>
                <div className="pickup-main-wrap">
                  <label className="pickup-label">Drop off Time</label>
                  <TimePicker
                    use12Hours
                    showNow={false}
                    format={format}
                    minuteStep={15}
                    secondStep={10}
                  />
                </div>
              </Col>
            </Row>

            {/* <Row className="time-picker">
          <Col xs={6}>
            <p>
              Pickup Time{" "}
              <TimePicker  use12Hours    showNow={false}    format={format}  minuteStep={15} secondStep={10}/>{" "}
            </p>
          </Col>

          <Col xs={6}>
            <p>
              Drop Off time <TimePicker />{" "}
            </p>
          </Col>
        </Row> */}
          </div>
        </Container>
      </Modal>
    </div>
  );
};

export default DateModel;
